import 'rxjs/add/operator/toPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';

import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from '../../environments/environment';

var HOST = environment.apiHost;

const headers = {
    'Content-Type': 'application/json'
};

export class ReleaseBundle {
    constructor(
        public id: number,
        public bundle_id: number,
        public version: string,
        public updated_date: Date,
        public component: string,
    ) { }
}


@Injectable()
export class ReleaseBundleService {

    constructor(private _HttpClient: HttpClient) { }

    async makeRequest(url, requestBody): Promise<any> {
        try {
            const response = await this._HttpClient.post(HOST + url, requestBody, { headers }).toPromise();
            return response;
        } catch (err) {
            console.log(err);
            return {error:'error'};
        }
    }

    getReleaseBundles(param, data?: any): Promise<any> {
        
        const requestBody = {
            session: param.session
        };

       return this.makeRequest('/release-bundles',requestBody);
    }

    getReleaseBundleData(param, data?: any): Observable<any> {        

        const requestBody = {
            bundle_id: param.bundle_id
        };        

        return this._HttpClient.post(HOST + '/get-release-bundle-data', requestBody, { headers })
            .map(response => { return response; })
    }

    removeFromBundle(param, data?: any): Promise<any> {
        

        const requestBody = {
            bundle_id: param.bundle_id,
            release_id: param.release_id,
            rbd_id: param.rbd_id,
            component: param.component
        };
        return this.makeRequest('/remove-from-bundle',requestBody); 
    }

    editReleaseBundle(param, data?: any): Promise<any> {

        const requestBody = {
            bundle_id: param.bundle_id,
            name: param.name,
            desc: param.desc
        };

        return this.makeRequest('/edit-bundle-name',requestBody);
    }

    discardBundle(param, data?: any): Promise<any> {        

        const requestBody = {
            id: param.id
        };

        return this.makeRequest('/discard-bundle',requestBody);
    }

    editReleaseBundleWorkflow(param, data?: any): Promise<any> {

        const requestBody = {
            bundle_id: param.bundle_id,
            workflow: param.workflow
        };

        return this.makeRequest('/update-bundle-flow',requestBody);
    }

    uploadReleaseBundleNote(param, data?: any): Promise<any> {

        const requestBody = {
            bundle_id: param.bundle_id,
            note: param.note,
            note_location: param.note_location
        };

        return this.makeRequest('/update-bundle-note',requestBody);
    }

    GetBundleMetadata(param, data?: any): Promise<any> {

        const requestBody = {
            bundle_id: param.bundle_id
        };

        return this.makeRequest('/bundle-metadata',requestBody);
    }

}
